/*
  LBA Gift with purchase (The Ball Earrings), Oct 2026.
  Cart progress, "add gift" button and currency painting.
  Config and formatting helpers (window.LBAGWP) are defined inline by snippets/lba-gwp.liquid (context: head).
  The discount itself is Shopify's automatic Buy X Get Y discount; this file only displays state and adds the gift line.
*/
(function () {
  var C = window.LBAGWP;
  if (!C) return;

  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function paintCart(el) {
    if (C.expired()) return;

    var t = C.thresholdCents();
    var q = parseInt(el.getAttribute('data-qualifying'), 10) || 0;
    var inCart = el.getAttribute('data-gift-in-cart') === 'true';
    var free = el.getAttribute('data-gift-free') === 'true';
    var hasCode = el.getAttribute('data-has-code') === 'true';
    var remaining = Math.max(0, t - q);

    var state;
    if (free) {
      state = 'free';
    } else if (remaining <= 0) {
      state = inCart ? (hasCode ? 'code' : 'pending') : 'unlocked';
    } else {
      state = inCart ? 'remaining-in-cart' : 'remaining';
    }

    var amount = C.fmt(remaining, { up: true });
    var signature = state + '|' + amount;
    if (el.getAttribute('data-painted') === signature) return;
    el.setAttribute('data-painted', signature);
    el.setAttribute('data-state', state);

    var msgEl = el.querySelector('[data-lba-gwp-message]');
    var tpl = el.getAttribute('data-msg-' + state) || '';
    if (msgEl) {
      msgEl.innerHTML = tpl
        .replace('[amount]', '<span class="lba-gwp-cart__amount">' + amount + '</span>')
        .replace('[threshold]', C.fmtThreshold());
    }

    var pct = (state === 'free' || remaining <= 0) ? 100 : Math.max(3, Math.min(100, (q / t) * 100));
    var bar = el.querySelector('[data-lba-gwp-progress]');
    if (bar) bar.style.width = pct.toFixed(1) + '%';
    var track = el.querySelector('[data-lba-gwp-track]');
    if (track) track.setAttribute('aria-valuenow', Math.round(pct));

    var add = el.querySelector('[data-lba-gwp-add]');
    if (add) add.hidden = state !== 'unlocked';

    var fine = el.querySelector('[data-lba-gwp-fine]');
    if (fine) fine.hidden = !(state === 'remaining' || state === 'remaining-in-cart');
  }

  function paintAll(root) {
    root = root || document;
    C.paint(root);
    var carts = root.querySelectorAll('[data-lba-gwp-cart]');
    for (var i = 0; i < carts.length; i++) paintCart(carts[i]);
  }

  /* Add the gift line. The automatic discount then makes it free when the order qualifies. */
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-lba-gwp-add]') : null;
    if (!btn) return;
    ev.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var box = btn.closest('[data-lba-gwp-cart]');
    var variantId = box ? parseInt(box.getAttribute('data-gift-variant'), 10) : 0;
    var error = box ? box.querySelector('[data-lba-gwp-error]') : null;
    if (!variantId) return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    if (error) error.hidden = true;

    fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        if (btn.closest('.quick-cart')) {
          /* Stiletto refreshes the quick cart and the header count on this event. */
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (error) error.hidden = false;
      });
  });

  /* The theme replaces cart markup after every change; repaint new blocks as they arrive. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      paintAll(document);
    });
  }

  function observe() {
    if (!('MutationObserver' in window)) return;
    var targets = document.querySelectorAll('.quick-cart, [data-section-type="cart"]');
    var mo = new MutationObserver(schedule);
    for (var i = 0; i < targets.length; i++) {
      mo.observe(targets[i], { childList: true, subtree: true });
    }
  }

  function init() {
    if (C.expired()) {
      document.documentElement.classList.add('lba-gwp-off');
      return;
    }
    paintAll(document);
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: sections are re-rendered in place. */
  document.addEventListener('shopify:section:load', function () {
    paintAll(document);
  });
})();
